import React from "react";
import "../styles/Header.scss";
import HeaderBreadcrumb from "./HeaderBreadcrumb";
import Logout from "../Auth/Logout";
import NotificationBell from "./NotificationBell";
import WhatsNewPopover from "./WhatsNewPopover";
const Header = ({ collapsed, onToggle, planInfo, hideBreadcrumb }) => {

    // Get badge styling based on plan status
    const getPlanBadgeStyle = () => {
        if (planInfo?.is_expired) {
            return { backgroundColor: '#EF4444', color: '#fff' }; // Red for expired
        }
        if (planInfo?.is_expiring_soon) {
            return { backgroundColor: '#F59E0B', color: '#fff' }; // Orange for expiring soon
        }
        return { backgroundColor: '#10B981', color: '#fff' }; // Green for active
    };

    return (
        <header className='header'>
            <div className='headerLeft'>
                {/* <img
                    src={collapsed ? "https://nmtsecurity-publicbucket.s3.us-west-2.amazonaws.com/dashboard/panel-left.svg" : "https://nmtsecurity-publicbucket.s3.us-west-2.amazonaws.com/dashboard/panel-left.svg"}
                    alt={collapsed ? "expand sidebar" : "collapse sidebar"}
                    onClick={onToggle}
                    className='toggleIcon'
                    height={40}
                    width={46}
                /> */}
                <HeaderBreadcrumb className='mb-0' hide={hideBreadcrumb} />
            </div>

            <div className='headerIcons'>
                {planInfo && (
                    <div
                        className="plan_info_badge"
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px',
                        }}
                    >
                        <span style={{ color: '#fff', fontWeight: '600', fontSize: '14px' }}>
                            {planInfo.plan_name}
                        </span>
                        <span
                            style={{
                                padding: '4px 10px',
                                borderRadius: '20px',
                                fontSize: '12px',
                                fontWeight: '500',
                                ...getPlanBadgeStyle()
                            }}
                        >
                            {planInfo.is_expired
                                ? 'Expired'
                                : planInfo.display_remaining || `${planInfo.days_remaining} days left`
                            }
                        </span>
                    </div>
                )}
                <WhatsNewPopover />
                <NotificationBell />
                <div className="user_profile" >
                    <Logout />
                </div>
            </div>
        </header>
    );
};

export default Header;
